import {capitalize} from 'lodash';
import React from 'react';
import clsx from 'clsx';

/**
 * Shows one discount type and the limit (like public 0%, private 20%...)
 * @param limit
 * @param type
 * @returns {Element}
 * @constructor
 */
export default function AgentDiscountIndicatorList({item}) {
  let discountsAllowed = (item.privateCeilingPercent > 0) || (item.publicCeilingPercent > 0);

  if (!discountsAllowed) {
    return <div>
      <span className="fa-stack mx-2">
        <span className="fa fa-tags  fa-stack-1x"/>
        <span className="fas fa-ban text-red-700  fa-stack-2x"/>
      </span>
      No discounts allowed.
    </div>
  }

  return <div className="">
    <span className="fa fa-tags mx-2"/>
    Discount:

    <AgentDiscountIndicator type="public" limit={item.publicCeilingPercent}/>
    <AgentDiscountIndicator type="suggest" limit={item.suggestedDiscountPercent}/>
    <AgentDiscountIndicator type="max" limit={item.privateCeilingPercent}/>

  </div>
}

function AgentDiscountIndicator({limit, type}) {
  let caption = capitalize(type);

  let className = clsx([
    "inline-block mx-2",
    // (limit < 0.01) ? " discount-zero" : "",
    (type === 'suggest' ? 'underline' : '')
  ]);

  limit = ("" + limit).replace('.0', '');

  return <div className={className}>
    <span>{caption}: </span>
    <b className="text-base">{limit}%</b>
  </div>;
}
